<body>
  <router-outlet></router-outlet>
  <app-cookie-consent-banner></app-cookie-consent-banner>
</body>